<div [class]="class ? class : 'main-navbar'">
  <div id="mainnav">
    <div class="header-nav-middle">
      <div class="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
        <div [class.show]="menuService.mainMenuToggle" class="offcanvas offcanvas-collapse order-xl-2">
          <div class="offcanvas-header navbar-shadow">
            <h5>{{ 'menu' | translate }}</h5>
            <button (click)="mainMenuClose()" class="btn-close lead" id="toggle_menu_btn" type="button">
              <div>
                <i class="ri-close-fill"> </i>
              </div>
            </button>
          </div>
          <div class="offcanvas-body">
            <!-- @if(menuService.skeletonLoader){
                                                                           <ul class="skeleton-menu navbar-nav">
                                                                             <li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                                                                           </ul>
                                                                         } @else {-->
            <ul class="navbar-nav">
              @for (navigation of menu?.navigations; track navigation) {
              <li [ngClass]="'nav-item'">
                @if (
                navigation.target != TargetType.EXTERNAL_PAGE &&
                navigation.target != TargetType.INTERNAL_PAGE
                ) {
                <a class="dropdown-item" [class.show]="true" (click)="redirect(navigation); mainMenuClose()">
                  {{ navigation.label }}
                </a>
                }
                @if (navigation.target === TargetType.INTERNAL_PAGE) {
                <a [routerLink]="['/' + navigation.path]" routerLinkActive="active" class="dropdown-item"
                  [class.show]="true" (click)="mainMenuClose()">
                  {{ navigation.label }}
                </a>
                }
              </li>
              }
            </ul>
            <!-- }-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>